var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewAllArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25736 0.696721L11.0303 5.46969C11.3232 5.76259 11.3232 6.23746 11.0303 6.53035L6.25736 11.3033C5.96447 11.5962 5.48959 11.5962 5.1967 11.3033C4.90381 11.0104 4.90381 10.5356 5.1967 10.2427L8.68934 6.75002H0V5.25002H8.68934L5.1967 1.75738C4.90381 1.46449 4.90381 0.989614 5.1967 0.696721C5.48959 0.403827 5.96447 0.403827 6.25736 0.696721Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewAllArrow);
export default __webpack_public_path__ + "static/media/viewAllArrow.81aa9c8c693d1abd94c385d258321d9c.svg";
export { ForwardRef as ReactComponent };